import { useQuery } from 'react-query'

import type { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.customFields.customFields}`

const fetchOpportunityCustomFieldSettings = async (): Promise<
  ICustomFieldFormSetting[]
> => {
  const response = await get(
    `${baseUrl}${ServiceConfig.customFields.opportunityFormSettings}`,
  )
  if (response.ok) return await response.json()
  return []
}

export const useOpportunityCustomFieldSettings = (enabled: boolean) =>
  useQuery<ICustomFieldFormSetting[]>(
    ['opportunityCustomFieldSettings'],
    fetchOpportunityCustomFieldSettings,
    { enabled },
  )
